<template>
    <section v-if="id">
        <div class="container">
            <div class="text-subtitle">Activation Confirmation</div>
            <q-card class="bg-white q-mt-sm">
                <q-card-section v-if="id">
                    <div class="q-pa-xl">
                        <div class="text-h5 q-pb-lg">Your activation for {{product.fullDescription}} has been successfully processed!</div>
                        <div class="q-pt-md">What to do next:</div>
                        <ol>
                            <li v-if="product.id.includes('LC')">
                                Download and install LoopCAD (if not already done):<br />
                                <p class="text-center q-pt-md">
                                    <a target="_blank" href="http://www.loopcad.com/downloads">www.LoopCAD.com/Downloads</a>
                                </p>
                            </li>
                            <li v-if="product.id.includes('HC')">
                                Download and install HeatCAD (if not already done):<br />
                                <p class="text-center q-pt-md">
                                    <a target="_blank" href="http://www.heatcad.com/downloads">www.HeatCAD.com/Downloads</a>
                                </p>
                            </li>
                            <li>
                                Input your new activation code:
                                <div class="text-h4 text-center q-pt-md">
                                    {{id}}
                                    <q-btn flat color="primary" size="md" icon="mdi-content-copy" dense
                                           class="q-mr-xs"
                                           @click="copyClipboard(id)">
                                        <q-tooltip>
                                            Copy to clipboard
                                        </q-tooltip>
                                    </q-btn>

                                </div>
                                <div class="text-center">
                                    <a v-if="product.id.includes('LC')" target="_blank" href="http://www.loopcad.com/enteractivation">How do I enter my activation code?</a>
                                    <a v-if="product.id.includes('HC')" target="_blank" href="http://www.heatcad.com/enteractivation">How do I enter my activation code?</a>
                                </div>
                            </li>
                        </ol>
                    </div>
                </q-card-section>

            </q-card>
        </div>
    </section>
</template>
<script>

    import { mapState } from 'vuex'

    export default {
        name: 'activation-confirm',
        props: {
            id: String,
            product: Object,
        },
        //data() {
        //    return {
        //        enumSendEmailTo: 0,
        //        showConfirmSend: false,
        //        emailRecipient: '',
        //        expanded: false,
        //        settings: {
        //            suppressScrollY: false,
        //            suppressScrollX: false,
        //            wheelPropagation: true
        //        }
        //    }
        //},
        //methods: {
        //    sendEmail() {
        //        const payload = {
        //            enumRecipients: this.enumSendEmailTo,
        //            orderId: this.order.orderID
        //        }
        //        this.$store.dispatch('sendReceiptEmail', payload).then(() => {
        //            this.showConfirmSend = false
        //            this.$q.notify({
        //                badgeClass: 'hidden',
        //                type: 'positive',
        //                message: 'Email has been sent'
        //            })
        //        })
        //    },
        //    showSendDialog(recipient, enumSendEmailTo) {
        //        this.enumSendEmailTo = enumSendEmailTo
        //        this.emailRecipient = recipient
        //        this.showConfirmSend = true
        //    }
        //},
        //computed: {
        //    //...mapState([
        //    //    'sendReceiptEmailPending',
        //    //    'sendReceiptEmailData',
        //    //]),
        //    receiptHTML() {
        //        if (this.order.receiptHTML) {
        //            if (this.$q.dark.isActive)
        //                return this.order.receiptHTML.replaceAll('#FFFFCC', '#181818')
        //            else
        //                return this.order.receiptHTML
        //        }
        //        return ''
        //    }
        //},
    }
</script>
<style>
</style>
